import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "com-na-1" }
const _hoisted_2 = { style: {"font-weight":"700"} }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = { class: "com-na" }
const _hoisted_5 = { class: "dialog-footer" }

import { ref, watch, computed } from 'vue';
import {
  geCompanyIvite,
  agreeEnterCompany,
  getUseMemberPrivige,
  getUserDetail,
} from '@/api/api';
import { createStore } from '@/vuex/store';
import { useRouter, useRoute } from 'vue-router';
import {
  getRouterName,
  isToken,
  rightJudgment,
  handleConsoleMenuList,
} from './utils/utils';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const isPhone = ref(false);

const store = createStore();
const inviteUrlDialog = ref(false);
const companyName = ref<string>('');
const companyCode = ref<string>('');
const inviteParam = ref<string>('');
isPhone.value = store.state.isPhone;

const noticeDialog = ref<boolean>(false);

if (localStorage.getItem('inviteParam')) {
  if (
    localStorage.getItem('inviteParam') &&
    JSON.parse(localStorage.getItem('user')) &&
    !JSON.parse(localStorage.getItem('user')).companyCode
  ) {
    inviteParam.value = localStorage.getItem('inviteParam');
    const msg = {
      inviteParam: localStorage.getItem('inviteParam'),
    };
    geCompanyIvite(msg).then((res) => {
      if (res.success) {
        companyName.value = res.data.name;
        inviteUrlDialog.value = true;
        companyCode.value = res.data.code;
      }
    });
  }
}
function getUser() {
  if (!localStorage.getItem('token')) return;
  getUserDetail().then((res) => {
    if (res.success) {
      // store.action.setToken(res.data.token);
      store.action.updateUser(res.data.user);
    }
  });
}

if (store.state.user?.companyTabIconUrl) {
  let relIcon = document.head.querySelector("link[rel='icon']");
  relIcon.href = store.state.user.companyTabIconUrl;
}
if (store.state.user?.companyTabTitle) {
  document.title = store.state.user.companyTabTitle;
}
watch(
  () => store.state.user?.companyIconWordUrl,
  (newV) => {
    if (newV?.tabIconUrl) {
      let relIcon = document.head.querySelector("link[rel='icon']");
      relIcon.href = newV.companyTabIconUrl;
    }
    if (newV?.companyTabTitle) {
      document.title = newV.companyTabTitle;
    }
  },
  {
    deep: true,
  }
);
getUser();
function sureRead() {
  noticeDialog.value = false;
  localStorage.setItem('onReadNotice', 'read');
  getUser();
}
if (localStorage.getItem('token')) {
  getUseMemberPrivige().then((res: any) => {
    if (res.success) {
      let allowRouterName = [];
      let authorizedRoute = false;
      store.action.updataUserPrivige(res.data);
      if (JSON.parse(localStorage.getItem('user'))) {
        const userDetail = JSON.parse(localStorage.getItem('user'));
        if (userDetail.authorizedRoute) {
          authorizedRoute = userDetail.authorizedRoute;
        }
      }
      const homeMenuList = [
        { name: t('home'), routerName: 'home' },
        { name: t('chat'), routerName: 'app' },
        // { name: t('paint'), routerName: 'paintPic' },
        { name: t('template'), routerName: 'template' },
      ];

      const consoloeMenuList = handleConsoleMenuList(res.data);
      store.action.updataRouterList(consoloeMenuList);
      if (res.data.memberGrade === 'ENTERPRISE') {
        if (authorizedRoute) {
          const menuHomeList = [
            { name: t('chat'), routerName: 'app' },
            { name:  t('template'), routerName: 'template' },
          ];
          if (rightJudgment('homePage')) {
            menuHomeList.splice(0, 0, { name: t('home'), routerName: 'home' });
          }
          // if (rightJudgment('paintPage')) {
          //   menuHomeList.splice(2, 0, { name: '绘画', routerName: 'paintPic' });
          // }
          if (rightJudgment('squarePage')) {
            menuHomeList.splice(2, 0, { name: t('square'), routerName: 'square' });
          }
          // if (rightJudgment('createApp')) {
          //   menuHomeList.splice(4, 0, { name: '创建', routerName: 'console' });
          // }
          store.action.updataHomeMenuList(menuHomeList);
        } else {
          store.action.updataHomeMenuList(homeMenuList);
        }
      } else {
        store.action.updataHomeMenuList(homeMenuList);
      }
    }
  });

  // getUserPrivilege().then((res) => {
  //   sessionStorage.setItem('privilege',res.data)
  // })
}

function cancelJoin() {
  inviteUrlDialog.value = false;
  if (localStorage.getItem('inviteParam')) {
    localStorage.removeItem('inviteParam');
  }
  router.replace({
    path: '/console/agents',
  });
}

function sureJoin() {
  const msg = {
    inviteParam: inviteParam.value,
  };
  agreeEnterCompany(msg).then((res) => {
    if (res.success) {
      if (localStorage.getItem('inviteParam')) {
        localStorage.removeItem('inviteParam');
      }
      inviteUrlDialog.value = false;
      store.action.updateUserCompanyCode(companyCode.value);
      store.action.updateUserCompanyName(companyName.value);
      router.go(0);
    }
  });
}
// const handleClickA = (event) => {
//   console.log(event.target.className);
// };
// const body = document.body;
// body.addEventListener('click', handleClickA);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: inviteUrlDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inviteUrlDialog).value = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      width: isPhone.value ? '90%' : '40%',
      class: "dia-p",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, { onClick: cancelJoin }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: sureJoin,
            type: "primary"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("确定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"font-size":"17px","color":"#303133"} }, "确认加入", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_icon, { style: {"color":"#e6a23c","font-size":"22px","margin-right":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_WarningFilled)
            ]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createTextVNode("是否确认加入 ")),
          _createElementVNode("span", _hoisted_2, _toDisplayString(companyName.value), 1),
          _cache[3] || (_cache[3] = _createTextVNode("的空间? "))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "width"]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: noticeDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((noticeDialog).value = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      "modal-class": 'right-top-dialog',
      width: isPhone.value ? '90%' : '40%'
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: sureRead,
            type: "primary"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("我知道了")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _cache[8] || (_cache[8] = _createElementVNode("div", null, "是否确定加入", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(companyName.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ], 64))
}
}

})